import angular from 'angular';

/**
 * Controla el gráfico pie para los informes
 */
InformeViewCtrl.$inject = ['InformeRest', '$http', 'InformeActionsService'];
export default function InformeViewCtrl(InformeRest, $http, InformeActionsService) {

    var TAG = 'InformeViewCtrl: ';

    var vm = this;
    vm.loading = {
        informe: true,
        graficos: true
    };

    vm.color = Sigo.var.color;
    cargarInforme(vm.informeId);

    vm.filtros = {};
    vm.cambiosSinGuardar = false;
    vm.onCambiaFiltros = function () {
        vm.cambiosSinGuardar = true;
        cargarGraficosInforme(vm.informeId, vm.filtros);
    };
    vm.onCambiaTipoFecha = function () {
        vm.filtros = {};
        // delete vm.filtros.periodo;
        // delete vm.filtros.start;
        // delete vm.filtros.end;
        cargarGraficosInforme(vm.informeId, vm.filtros);
    };
    vm.opcionesFecha = [
        {label: Lang.get('estadisticas.rango_fechas'), value: 'fecha_fija'},
        {label: Lang.choice('estadisticas.periodo', 1), value: 'fecha_periodo'}
    ];
    vm.tipoFiltroFecha = 'fecha_periodo';
    vm.periodos = [];
    cargarPeriodos();

    function cargarPeriodos() {
        var url = Sigo.url + '/estadisticas/graficos/periodos';
        $http.get(url).then(function (respuesta) {
            vm.periodos = respuesta.data;
        })
    }

    vm.eliminarDeInforme = function (informe, grafico) {
        var opcionesDialog = {
            title: Lang.get('estadisticas.quitar_grafico_informe_titulo'),
            message: Lang.get('estadisticas.quitar_grafico_informe_mensaje'),
            onOk: function () {
                InformeActionsService.eliminarGraficoDeInforme(informe, grafico).then(function () {
                    Sigo.UI.Toast.success('', Lang.get('estadisticas.quitar_grafico_informe_exito'));
                    vm.graficos = vm.graficos.filter(function (item) {
                        return item.pivot.id != grafico.pivot.id;
                    })
                });
            }
        };
        Sigo.UI.Dialog.confirm(opcionesDialog);
    };

    vm.guardarFiltros = function (informeId, filtros) {
        var url = Sigo.url + '/api/v1/informes/' + informeId;
        var data = {
            parametros: JSON.stringify(filtros)
        };
        $http.put(url, data).then(function (response) {
            vm.cambiosSinGuardar = false;
            Sigo.UI.Toast.success('', 'Informe actualizado!');
        })
    };

    function cargarInforme(informeId) {
        vm.loading.informe = true;
        var promesa = InformeRest.get({'id': informeId}).$promise;
        promesa.then(function (informe) {
            vm.informe = informe;
            vm.loading.informe = false;
            vm.filtros = (vm.informe.parametros.length > 0) ? JSON.parse(vm.informe.parametros) : {};
            if (typeof vm.filtros.periodo !== 'undefined')
                vm.tipoFiltroFecha = 'fecha_periodo';
            else if (typeof vm.filtros.periodo !== 'start' || typeof vm.filtros.periodo !== 'end')
                vm.tipoFiltroFecha = 'fecha_fija';

            cargarGraficosInforme(informeId, vm.filtros);

        });
        return promesa;
    }

    function cargarGraficosInforme(informeId, filtros) {
        vm.loading.graficos = true;
        var promesa = $http.get(Sigo.url + '/estadisticas/informes/graficos/' + informeId, {params: filtros});
        promesa.then(function (respuesta) {
            vm.graficos = respuesta.data;
            vm.loading.graficos = false;
        });
        return promesa;
    }

    /**
     * Si el informe tiene unos filtros estos tienen que aplicarse a los gráficos
     * @param informe
     */
    function procesarInforme(informe) {

        if (typeof informe != 'undefined') {
            informe.parametros = issetAndNotEmpty(informe.parametros) ? angular.fromJson(informe.parametros) : {};

            informe.graficos.forEach(function (grafico) {
                grafico.parametros = issetAndNotEmpty(grafico.parametros) ? angular.fromJson(grafico.parametros) : {};
                grafico.parametros = angular.merge(grafico.parametros, informe.parametros);
            });
        }

        return informe;
    }
}